import { useMutation, useQueryClient } from '@tanstack/react-query'

import { venueProfileQueryKey } from '@/hooks/useVenueProfile'
import type { ApiError } from '@/lib/api/errors'
import { deleteCourt } from '@/lib/venue/courtApi'
import type { CourtListView } from '@/lib/venue/courtTypes'

import { courtsQueryKey } from './useCourts'

/**
 * 코트 삭제 (#597 §4).
 * 코트 수가 바뀌므로 등록과 동일하게 구장 프로필 쿼리를 무효화한다(설계 D3).
 */
export function useDeleteCourt(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<CourtListView, ApiError, number>({
    mutationFn: (courtId) => deleteCourt(venueId, courtId),
    onSuccess: (data) => {
      queryClient.setQueryData(courtsQueryKey(venueId), data)
      void queryClient.invalidateQueries({ queryKey: venueProfileQueryKey(venueId) })
    },
  })
}
